// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const { jwt } = useJwt({
  loginEndpoint: '/auth/login',
  keyLoginEndpoint: '/auth/keylogin',
  verifyLoginOTPEndpoint: '/auth/verify-otp',
  resendLoginOTPEndpoint: '/auth/resend-otp'
})

export default jwt
